import { ShieldOff } from "lucide-react";

export function ForbiddenScreen({ permission }: { permission: string }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20">
      <div className="w-14 h-14 rounded-full bg-danger-soft text-danger flex items-center justify-center mb-4">
        <ShieldOff size={24} strokeWidth={1.75} />
      </div>
      <h1 className="nx-h2 mb-2">Acceso restringido</h1>
      <p className="text-sm text-fg-muted max-w-md">
        No tienes el permiso necesario para ver esta sección.
      </p>
      <code className="mt-3 text-2xs font-mono px-2 py-1 rounded bg-bg-subtle border border-border text-fg-subtle">
        {permission}
      </code>
      <p className="text-xs text-fg-subtle mt-5 max-w-sm">
        Si crees que es un error, contacta al Owner para que ajuste tu rol en Nexus Control.
      </p>
    </div>
  );
}
